import React from "react";
import { Row, Col } from "react-bootstrap";

const Overview = () => {
  return (
    <div className="smleft">
      <h5 className="card-title mt-1 mb-4 header-title text-white position-relative">
        Letter Requests Overview
      </h5>
      <Row className="mb-4">
        <Col className="border-end">
          <div className="d-flex align-items-center">
            <div className="stateicon">
              <svg
                width="22"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.4132 2.79578V0.897271C18.4132 0.718167 18.2699 0.539062 18.055 0.539062H2.18633C2.00723 0.539062 1.82812 0.682346 1.82812 0.897271V20.1689C1.82812 20.348 1.97141 20.5271 2.18633 20.5271H4.8729V3.83458C4.8729 3.26145 5.33857 2.79578 5.91171 2.79578H18.4132Z"
                  fill="white"
                />
                <path
                  d="M10.318 7.27344C9.92395 7.30926 9.60156 7.52418 9.60156 7.91821C9.60156 8.34806 9.88813 8.45553 10.318 8.59881V7.27344ZM11.6075 10.354C11.6075 9.92418 11.2851 9.7809 10.8195 9.63762V10.9988C11.2135 10.963 11.6075 10.7839 11.6075 10.354Z"
                  fill="white"
                />
                <path
                  d="M21.8135 3.47656H5.90899C5.72989 3.47656 5.55078 3.61985 5.55078 3.83477V23.1064C5.55078 23.2855 5.69406 23.4646 5.90899 23.4646H21.7776C21.9567 23.4646 22.1359 23.3213 22.1359 23.1064V3.83477C22.1359 3.65567 21.9926 3.47656 21.8135 3.47656ZM8.63138 7.99C8.63138 7.05865 9.3478 6.48552 10.2791 6.4497V6.05567H10.7806V6.4497C11.3538 6.48552 11.8553 6.66462 12.3568 7.02283L11.8553 7.73925C11.5329 7.4885 11.1388 7.34522 10.7806 7.3094V8.74223H10.8165C11.7836 8.95716 12.5359 9.31537 12.5359 10.3184C12.5359 11.2855 11.7478 11.8228 10.8165 11.8587V12.396H10.315V11.8228C9.63436 11.7512 8.98959 11.4646 8.45227 10.999L9.02541 10.3184C9.45526 10.6766 9.88511 10.9273 10.3508 10.999V9.53029C9.3478 9.27955 8.63138 8.95716 8.63138 7.99ZM19.1985 20.9213H8.52392C8.34481 20.9213 8.16571 20.7781 8.16571 20.5631C8.16571 20.384 8.30899 20.2049 8.52392 20.2049H19.1627C19.3418 20.2049 19.5209 20.3482 19.5209 20.5631C19.5209 20.7781 19.3776 20.9213 19.1985 20.9213ZM19.1985 18.0915H8.52392C8.34481 18.0915 8.16571 17.9482 8.16571 17.7333C8.16571 17.5542 8.30899 17.3751 8.52392 17.3751H19.1627C19.3418 17.3751 19.5209 17.5184 19.5209 17.7333C19.5209 17.9124 19.3776 18.0915 19.1985 18.0915ZM19.1985 15.2258H8.52392C8.34481 15.2258 8.16571 15.0825 8.16571 14.8676C8.16571 14.6527 8.30899 14.5094 8.52392 14.5094H19.1627C19.3418 14.5094 19.5209 14.6527 19.5209 14.8676C19.5209 15.0825 19.3776 15.2258 19.1985 15.2258ZM19.1985 12.396H13.9329C13.7538 12.396 13.5747 12.2527 13.5747 12.0378C13.5747 11.8587 13.7179 11.6795 13.9329 11.6795H19.1627C19.3418 11.6795 19.5209 11.8228 19.5209 12.0378C19.5209 12.2527 19.3776 12.396 19.1985 12.396ZM19.1985 9.56611H13.9329C13.7538 9.56611 13.5747 9.42283 13.5747 9.20791C13.5747 8.99298 13.7179 8.8497 13.9329 8.8497H19.1627C19.3418 8.8497 19.5209 8.99298 19.5209 9.20791C19.5209 9.42283 19.3776 9.56611 19.1985 9.56611ZM19.1985 6.73626H13.9329C13.7538 6.73626 13.5747 6.59298 13.5747 6.37805C13.5747 6.19895 13.7179 6.01985 13.9329 6.01985H19.1627C19.3418 6.01985 19.5209 6.16313 19.5209 6.37805C19.5209 6.55716 19.3776 6.73626 19.1985 6.73626Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="idesc">
              <p>All</p>
              <h3 className="my-0">0</h3>
            </div>
          </div>
        </Col>
        <Col>
          <div className="d-flex align-items-center justify-content-center">
            <div className="stateicon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM16.3 9.61L11.73 15.61C11.6368 15.731 11.5172 15.8291 11.3803 15.8967C11.2433 15.9643 11.0927 15.9996 10.94 16C10.7881 16.0008 10.638 15.967 10.5011 15.9012C10.3643 15.8353 10.2442 15.7392 10.15 15.62L7.71 12.51C7.62924 12.4063 7.5697 12.2876 7.53479 12.1609C7.49988 12.0341 7.49027 11.9017 7.50652 11.7713C7.52277 11.6408 7.56456 11.5148 7.6295 11.4005C7.69444 11.2862 7.78126 11.1858 7.885 11.105C8.09453 10.9419 8.36026 10.8687 8.62375 10.9015C8.75421 10.9178 8.8802 10.9596 8.99452 11.0245C9.10884 11.0894 9.20924 11.1763 9.29 11.28L10.92 13.36L14.7 8.36C14.7801 8.25494 14.8801 8.16669 14.9943 8.10029C15.1086 8.03388 15.2347 7.99062 15.3657 7.97298C15.4966 7.95534 15.6297 7.96365 15.7574 7.99746C15.8851 8.03126 16.0049 8.08989 16.11 8.17C16.2151 8.25011 16.3033 8.35012 16.3697 8.46433C16.4361 8.57855 16.4794 8.70472 16.497 8.83565C16.5147 8.96658 16.5063 9.0997 16.4725 9.22742C16.4387 9.35514 16.3801 9.47494 16.3 9.58V9.61Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="idesc">
              <p>Issued</p>
              <h3 className="my-0">0</h3>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col className="border-end">
          <div className="d-flex align-items-center position-relative">
            <div className="stateicon">
              <svg
                width="23"
                height="25"
                viewBox="0 0 26 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.81149 9.42236H13.8638C14.1176 9.42236 14.3519 9.30386 14.4788 9.11173C14.6055 8.91944 14.6055 8.68262 14.4788 8.49031C14.3519 8.29818 14.1176 8.17969 13.8638 8.17969H6.81149C6.55789 8.17969 6.32344 8.29818 6.19674 8.49031C6.06984 8.68261 6.06984 8.91943 6.19674 9.11173C6.32344 9.30386 6.55789 9.42236 6.81149 9.42236Z"
                  fill="white"
                />
                <path
                  d="M6.81149 11.6487H10.5581C10.8117 11.6487 11.0461 11.5303 11.1728 11.3381C11.2997 11.1458 11.2997 10.909 11.1728 10.7169C11.0461 10.5246 10.8117 10.4062 10.5581 10.4062H6.81149C6.55789 10.4062 6.32344 10.5246 6.19674 10.7169C6.06984 10.909 6.06984 11.1458 6.19674 11.3381C6.32344 11.5303 6.55789 11.6487 6.81149 11.6487Z"
                  fill="white"
                />
                <path
                  d="M20.6854 14.8881V10.1364C20.6854 9.74538 20.5136 9.36908 20.2055 9.08571L18.0064 7.06184V3.76618C18.0064 3.54426 17.9056 3.33131 17.7261 3.17422C17.5468 3.01713 17.3035 2.92894 17.0497 2.92894H13.5139L11.4228 1.00223C11.1427 0.743912 10.7537 0.597656 10.3469 0.597656C9.94006 0.597656 9.55106 0.743912 9.27092 1.00223L7.17711 2.92911L3.64407 2.92894C3.39027 2.92894 3.14693 3.01714 2.96761 3.17423C2.78809 3.33132 2.68731 3.54427 2.68731 3.76618V7.06185L0.485348 9.0881C0.17584 9.37011 0.00212941 9.74558 0 10.1364V18.8727C0 19.2731 0.181837 19.657 0.505265 19.94C0.828693 20.223 1.26745 20.3822 1.72492 20.3822H14.4207C14.4207 18.9271 15.0801 17.5316 16.2547 16.5015C17.4291 15.4714 19.0225 14.8912 20.6853 14.888L20.6854 14.8881ZM16.0846 12.0197L11.0483 15.5506C10.8515 15.6884 10.607 15.7636 10.355 15.7636C10.1029 15.7636 9.85842 15.6884 9.66167 15.5506L4.6006 11.9664V4.60332H16.0841L16.0846 12.0197Z"
                  fill="white"
                />
                <path
                  d="M6.81149 7.19562H13.8638C14.1176 7.19562 14.3519 7.0773 14.4788 6.885C14.6055 6.69287 14.6055 6.45605 14.4788 6.26375C14.3519 6.07162 14.1176 5.95312 13.8638 5.95312H6.81149C6.55789 5.95312 6.32344 6.07162 6.19674 6.26375C6.06984 6.45605 6.06984 6.69286 6.19674 6.885C6.32344 7.0773 6.55789 7.19562 6.81149 7.19562Z"
                  fill="white"
                />
                <path
                  d="M20.6843 16.1563C19.4054 16.1576 18.1798 16.6032 17.2764 17.3952C16.373 18.1871 15.8662 19.2607 15.8672 20.3796C15.8682 21.4987 16.3769 22.5714 17.2816 23.3622C18.1864 24.1529 19.413 24.5969 20.6916 24.5966C21.9702 24.5961 23.1965 24.1512 24.1004 23.3599C25.0044 22.5685 25.5124 21.4953 25.5124 20.3763C25.5108 19.2567 25.0015 18.1834 24.0962 17.392C23.1909 16.6008 21.9637 16.1562 20.6843 16.1562V16.1563ZM22.9029 19.7964L20.5788 21.8301V21.83C20.469 21.9273 20.319 21.982 20.1627 21.982C20.0066 21.982 19.8567 21.9273 19.7468 21.83L18.4906 20.7307C18.2734 20.4898 18.296 20.1448 18.5433 19.9271C18.7905 19.7094 19.1847 19.6878 19.4611 19.8765L20.1517 20.4808L21.9072 18.9423C22.0372 18.8282 22.2138 18.764 22.398 18.764C22.5821 18.764 22.7587 18.8282 22.8889 18.9423C23.0201 19.0562 23.094 19.2112 23.094 19.3729C23.094 19.5347 23.0201 19.6898 22.8889 19.8037L22.9029 19.7964Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="idesc">
              <p>Pending</p>
              <h3 className="my-0">0</h3>
            </div>
          </div>
        </Col>
        <Col>
          <div className="d-flex align-items-center justify-content-center">
            <div className="stateicon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 17C11.4 17 11 16.6 11 16C11 15.4 11.4 15 12 15C12.6 15 13 15.4 13 16C13 16.6 12.6 17 12 17ZM13 12C13 12.6 12.6 13 12 13C11.4 13 11 12.6 11 12V8C11 7.4 11.4 7 12 7C12.6 7 13 7.4 13 8V12Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="idesc">
              <p>Rejected</p>
              <h3 className="my-0">0</h3>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Overview;
